// src/components/reports/ReportTintContext.js
//
// Provides a boolean `showTint` value to all ReportTemplate components
// without prop-drilling through every CollapsibleSection / SubHeading call.
//
// Usage:
//   Provider — wrap the report paper content in ReportPreview.jsx:
//     <ReportTintContext.Provider value={showDataTint}>…</ReportTintContext.Provider>
//
//   Consumer — inside ReportTemplate.jsx components:
//     const showTint = useReportTint();

import { createContext, useContext } from 'react';

export const ReportTintContext = createContext(false);
export const useReportTint = () => useContext(ReportTintContext);
